<template>
  <div class="input__wrap">
    <div
        class="input__item"
        v-for="(label, index) in array"
        :key="label.id"
      >
      <input
        type="checkbox"
        :id="keyName + '_0' + index"
        :name="keyName"
        :value="label.value"
        :checked="label.value === selectValue"
        :disabled="disabled"
        @change="$emit('change', $event.target.value,)"
      />
      <label class="icon" :for="keyName + '_0' + index">
        {{ label.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    keyName: {
      type: String,
      required: true,
    },
    array: {
      type: Array,
      required: true,
    },
    radioWidth: {
      type: String,
      required: false,
      default: 'calc((100% - 10px) / 2)'
    },
    selectValue: {
      type: [String, Number],
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  &__wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 0 10px;
    list-style: none;
    margin: 0 16px 10px 0;
  }
  &__item {
    label {
      display: block;
      background: $base_gray_color;
      width: 100%;
      padding: 10px;
      height: auto;
      box-sizing: border-box;
      border-radius: $radius;
      cursor: pointer;
      font-size: 14px;
      font-weight: 700;
      color: $base_text_color;
      transition: 0.3s all;
      min-width: 120px;
      text-align: center;
    }
    input[type='checkbox'] {
      display: none;
      visibility: hidden;
      opacity: 0;
    }
    input[type='checkbox']:checked + label {
      background: $main_color;
      color: #fff;
      box-shadow: $box_shadow;
    }
  }
}

</style>